import React from "react";
import { useCart } from "../../providers/CartProvider";
import { Modal } from "antd";

interface QualityControlProps {
    productName: string;
    productId: number;
}

const ProductDetailQualityControl: React.FC<QualityControlProps> = ({ productName, productId }) => {
    const { qualityControl, addItem, removeItem, updateItemQty } = useCart();
    const { status, data } = qualityControl(productId);
    const [quantity, setQuantity] = React.useState<number>(data?.quantity ?? 0);
    const displayName = data?.product?.name || productName || "Sản phẩm";
    const imageUrl = data?.product?.avatar || "";
    const token = localStorage.getItem('token') || '';

    if (!token || token === '') {
        return null;
    }
    else {
        return (
            <div className="styles_container__RJvSq qty-control-wrapper">

                {/* MINUS */}
                <div
                    className="styles_minusContainer__61A8K qty-control-minus"
                    role="button"
                    onClick={() => {
                        if (quantity <= 0 && data?.id) {
                            removeItem(data?.id.toString() ?? '', productName);
                            return;
                        }

                        if (quantity === 1 && data?.id) {
                            Modal.confirm({
                                title: 'Xác nhận',
                                content: (
                                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                                        {imageUrl ? (
                                            <img
                                                src={imageUrl}
                                                alt={displayName}
                                                style={{ width: 56, height: 56, objectFit: "contain", borderRadius: 8 }}
                                            />
                                        ) : null}
                                        <div style={{ lineHeight: 1.4 }}>
                                            Bạn có chắc muốn xóa
                                            <div style={{ fontWeight: 600 }}>{displayName}</div>
                                            khỏi giỏ hàng?
                                        </div>
                                    </div>
                                ),
                                okText: 'Xóa',
                                cancelText: 'Hủy',
                                okButtonProps: { danger: true },
                                onOk: async () => { await removeItem(data?.id.toString() ?? '', productName); },
                            });
                        }
                        else {
                            setQuantity((prevQuantity) => Math.max(prevQuantity - 1, 0));
                            addItem(productId, -1, true, productName);
                        }
                    }}
                >
                    <div className="styles_minus__BA244" />
                </div>

                {/* INPUT */}
                <div className="MuiInput-root MuiInputBase-root MuiInputBase-colorPrimary qty-control-input css-1f63zq5">
                    <input
                        name="inputNumber"
                        type="number"
                        className="MuiInput-input MuiInputBase-input css-mnn31"
                        min={0}
                        
                        value={quantity || data?.quantity || 0}
                        onChange={(e) => {
                            const newValue = Number(e.target.value);
                            setQuantity(newValue);
                        }}
                        onBlur={() => {
                            updateItemQty(productName,productId, quantity ?? 0);
                        }}
                    />
                </div>

                {/* PLUS */}
                <div
                    className="styles_addContainer__07KXb qty-control-plus"
                    role="button"
                    onClick={() => {
                        setQuantity((prevQuantity) => prevQuantity + 1);
                        addItem(productId, 1, true, productName);
                    }}
                >
                    <div className="styles_addIcon__SXVYV" />
                </div>

            </div>
        );
    }

};

export default ProductDetailQualityControl;